import { render } from "./AlertMessage.vue?vue&type=template&id=54bd3a27&scoped=true"
import script from "./AlertMessage.vue?vue&type=script&lang=js"
export * from "./AlertMessage.vue?vue&type=script&lang=js"

import "./AlertMessage.vue?vue&type=style&index=0&id=54bd3a27&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54bd3a27"]])

export default __exports__